<ng-container>
  <div
      [showIfHasCapability]="[
        {
          capabilityString: 'CanAccessAdminWing',
          type: 'client'
        }
      ]"
  class="content85percent capabilities-margin"
  >
  <div class="page-header-bar">
    <div class="float-start">
      <h1>Admin: Manage Users</h1>
      <p>Use the search function below to find specific users. Once located, you have the ability to manage them by adjusting their role type, adding or removing roles, and even creating new users or deleting existing ones.</p>
    </div>
  </div>
  <form [formGroup]="searchForm" class="clrsgn-form search-form">
    <div class="searchFormBody row">
      <span class="col">
        <mat-form-field appearance="fill" class="clrsgn-form-field">
          <mat-label class="clrsgn-label">Organization</mat-label>
          <mat-select formControlName="client" data-cy="organizationDropdown">
            @for (client of (currentUserClientAdminAccounts$ | async)?.clients; track client) {
              <mat-option
                [value]="client.clientId"
                (click)="setClient(client)"
                >
                {{ client.clientName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </span>
      <span class="col">
        <mat-form-field appearance="fill" class="clrsgn-form-field">
          <mat-label class="clrsgn-label">Search Email</mat-label>
          <input
            matInput
            class="search-input"
            formControlName="searchEmail"
            type="text"
            id="searchEmail"
            (keyup)="handleKeyUp($event)"
            />
            <button class="btn-primary float-end search-button" type="button" (click)="setSearchText()">
              <i class="fa-solid fa-magnifying-glass"></i>
            </button>
          </mat-form-field>
        </span>
        <span class="col">
          <mat-form-field appearance="fill" class="clrsgn-form-field">
            <mat-label class="clrsgn-label">Search Name</mat-label>
            <input
              matInput
              class="search-input"
              formControlName="searchName"
              type="text"
              id="searchName"
              (keyup)="handleKeyUp($event)"
              />
              <button class="btn-primary float-end search-button" type="button" (click)="setSearchText()">
                <i class="fa-solid fa-magnifying-glass"></i>
              </button>
            </mat-form-field>
          </span>
          <span class="col">
            <mat-form-field appearance="fill" class="clrsgn-form-field">
              <mat-label class="clrsgn-label">Filter By Role</mat-label>
              <mat-select formControlName="roleFilter" data-cy="roleDropdown">
                @for (role of filterAccountRoles; track role) {
                  <mat-option
                    [value]="role.value"
                    (click)="setSearchRole()"
                    >
                    {{ role.displayValue }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </span>
        </div>
      </form>
      @if (clientAccounts.length === 0 && this.isLoading === false) {
        <div class="section-box">
          <h4>Looks like that client doesn't have any users that you can edit yet!</h4>
          <p>Click the 'Add User' button to start adding new signing agents, client admins, order managers etc.</p>
          <button type="button"
            class="btn-primary"
            (click)="openAddUserModal()">
            + Add User
          </button>
        </div>
      }
      <button type="button"
        class="btn-primary float-end mb-2"
        (click)="openAddUserModal()">
        + Add User
      </button>
      @if (clientAccounts.length > 0 && clientAccountsDisplay.length === 0 && this.isLoading === false) {
        <p class="mt-1">No results for the given search criteria</p>
      }
      @if (clientAccountsDisplay.length > 0) {
        <div>
          <h2 class="float-start">Users</h2>
          <table id="clientAccountSectionTable" class="table table-responsive" aria-describedby="Client accounts for selected client">
            <thead>
              <tr>
                <th scope="col" class="text-start sortable" class="name-table-header" [ngClass]="{'active-sort-column': sortColumn == 'Name'}" style="width: 40vw" (click)="changeSort('name')" (keyup)="handleKeyUp($event, 'name')">
                  Name
                  @if (!sortAscending && sortColumn === 'name') {
                    <span class="fas fa-arrow-down"></span>
                  }
                  @if (sortAscending && sortColumn === 'name') {
                    <span class="fas fa-arrow-up"></span>
                  }
                </th>
                <th scope="col" class="text-start sortable" class="name-table-header" [ngClass]="{'active-sort-column': sortColumn == 'EmailAddress'}" style="width: 40vw" (click)="changeSort('email')" (keyup)="handleKeyUp($event, 'email')">
                  Email
                  @if (!sortAscending && sortColumn === 'email') {
                    <span class="fas fa-arrow-down"></span>
                  }
                  @if (sortAscending && sortColumn === 'email') {
                    <span class="fas fa-arrow-up"></span>
                  }
                </th>
                <th scope="col" class="text-start" [ngClass]="{'active-sort-column': sortColumn == 'ClientLoanNumber'}" style="width: 50vw">
                  Roles
                  <mat-icon class="tooltip-icon" matTooltip="Add and remove roles that apply to the user" matTooltipPosition="below" matTooltipShowDelay="500" svgIcon="information"></mat-icon>
                </th>
                <th scope="col" class="text-start" [ngClass]="{'active-sort-column': sortColumn == 'Actions'}" style="width: 10vw">
                  Actions
                </th>
              </tr>
            </thead>
            @if (clientAccountsDisplay.length > 0) {
              <tbody>
                @for (clientAccount of clientAccountsDisplay; track clientAccount) {
                  <tr>
                    <td>
                      {{ clientAccount.name }}
                    </td>
                    <td>
                      {{ clientAccount.email }}
                    </td>
                    <td>
                      <mat-form-field class="clrsgn-form-field">
                        <mat-select placeholder="Roles" [(value)]="clientAccount.roles" multiple>
                          @for (role of accountRoles; track role) {
                            <mat-option #matOption [value]="role.value" (click)="editClientAccount(matOption.selected, clientAccount, role.value)">{{ role.displayValue }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn-secondary action-btn reset-btn"
                        (click)="onDelete(clientAccount)"
                        >
                        <i class="fas fa-trash-alt action-icon cursor-hand"></i>
                        Delete
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            }
          </table>
        </div>
      }
      <div [hidden]="clientAccountsDisplay.length === 0" class="row pagination-section">
        <div class="col align-self-end">
          <app-pagination-form
            [numPages]="pagination.totalPages"
            [currentPage]="pagination.pageNumber"
            [currentItemsPerPage]="pagination.pageSize"
            [canGoForward]="pagination.canMoveForward"
            [canGoBackward]="pagination.canMoveBackward"
            (change)="onPaginatorChanged()">
          </app-pagination-form>
        </div>
      </div>
    </div>
  </ng-container>
